/**
 * Reset Bank Details Interfaces
 */

/**
 * User with Bank Details
 */
export interface UserWithBankDetails {
  user_id: number;
  username: string;
  role_name: string;
  mobile: string;
  email: string;
  region_name: string;
  state_name: string;
  cityname: string;
  bank_detail_type: 1 | 2; // 1 = UPI, 2 = NEFT
  upi_id?: string; // Present when bank_detail_type = 1
  account_number?: string; // Present when bank_detail_type = 2
  ifsc_code?: string; // Present when bank_detail_type = 2
}

/**
 * Query parameters for getting users with bank details
 */
export interface UserBankDetailsSearchParams {
  mobile_num?: string;
}

/**
 * API Response for getting users with bank details
 */
export interface UserBankDetailsApiResponse {
  body: {
    data: UserWithBankDetails[];
  };
  headers: {
    "X-Pagination-Total-Count"?: number;
  };
}

/**
 * Payload for resetting bank account
 */
export interface ResetBankAccountPayload {
  user_id: number;
  program_id: number;
}

/**
 * API Response for resetting bank account
 */
export interface ResetBankAccountApiResponse {
  body: {
    data: {
      message: string;
    };
  };
}
